import { useContext, useEffect, useState } from "react";
import { StandardComp } from "../atoms/standardComp";
import { CourseTableComp, SuggestCourseTableComp } from "../components/courseTableComp";
import { GraphComp } from "../components/graphComp";
import { KpiComp } from "../components/kpiComp";
import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { RecentActivities } from "../components/recentActivities";
import { TopBar } from "../components/topbar";
import { ReportsOverview } from "../molecule/reportsOverview";
import { getAPI, postAPI, updateAPI } from "../api/api";
import { SuggestedCourseGrid } from "../components/suggestCourse";
import { Alert } from "../components/alert";
import { SuggestionModal } from "../components/customModals";
import { StandardButton } from "../atoms/buttons";
import { HeaderTitle } from "../molecule/headerTitle";
import { ShowLayoutError } from "../molecule/ShowErrorLayout";
import { Toast } from "../atoms/toast";
import { vi } from "date-fns/locale";
import { PageContext } from "../App";


export function Reports({ pageSwap, props }) {
    const [suggestionVisible, setSuggestionVisible] = useState(false);
    const openSuggestionModal = () => setSuggestionVisible(true);
    const closeSuggestionModal = () => setSuggestionVisible(false);
    const [kpiContents, setKpiContents] = useState({})
    const [showMore, setShowMore] = useState(false);
    const [allCourses, setAllCourses] = useState([]);
    const [selectedCourseIds, setSelectedCourseIds] = useState([]);
    const [visibleKpiKeys, setVisibleKpiKeys] = useState([]);
    const [period, setPeriod] = useState(12);
    const [allReports, setAllReports] = useState([]);
    const [graphDataset, setGraphDataset] = useState([]);
    const [activeGraphId, setActiveGraphId] = useState("1");
    const [errorMessage, setErrorMessage] = useState("");
    const [userCourseStats, setUserCourseStats] = useState([]);
    const navigationContext = useContext(PageContext);

    useEffect(() => {
        
        loadCourses();
    }, []);


    const loadUserCourseStats = async (selectedCourseIds) => {
        const courseIDs = selectedCourseIds?.length > 0 ? selectedCourseIds : [navigationContext.sidebar.courseID];
        const query = `api/reports/users/course-stats?course_ids=${courseIDs.join(",")}`;

        const res = await getAPI(query);
        if (res.status === "ok") {
            setUserCourseStats(res.data);
        }
    };
    const loadCourses = async () => {
        const query = `api/courses/filter?filter=creation_date&order=DESC&published_filters=active_lessons`;
        const response = await getAPI(query);
        const courses = response.data;
        setAllCourses(courses);
    };
    const displayedCourses = showMore ? allCourses : allCourses.slice(0, 4);
    

        useEffect(() => {
        if (navigationContext.sidebar?.courseID && allCourses.length > 0) {
            const id = navigationContext.sidebar.courseID;
            handleCourseToggle(id, true);
        }
    }, [allCourses, navigationContext.sidebar?.courseID]);
    
      
      const handleCourseToggle = (id, override = false) => {
        setErrorMessage("");
        if (override) {
            setSelectedCourseIds([id]);
            return;
        }


        setSelectedCourseIds((prev) => {
            if (prev.includes(id)) {
                return prev.filter(cid => cid !== id);
            } else {
                if (prev.length >= 5) {
                    setErrorMessage("Je kunt maximaal 5 cursussen selecteren.");
                    setTimeout(() => {
                        setErrorMessage("");
                    }, 3500);
                    return prev;
                }
                return [...prev, id];
            }
        });
    };




    const handleActiveGraph = (id) => {
        setActiveGraphId((prev) => (prev === id ? id : id));
         setGraphDataset(kpiContents[id].graph_array.map((item) => (parseInt(item.row_value))));
    };

    if (allCourses.length === 0 && kpiContents.length === 0) {
        return (
            <ShowLayoutError
                iconType="no-reports"
                errorTitle="Geen suggesties beschikbaar"
                message="Er zijn momenteel geen rapportages of aanbevelingen om weer te geven."
            />
        );
    }
    return (
        <>
            {errorMessage && (
                <Toast
                    className={"max-course-alert"}
                    message={errorMessage}
                    type="error"
                    duration={3500}
                />
            )}
            {suggestionVisible && (
                <SuggestionModal
                    ref={null}
                    visible={suggestionVisible}
                    dismiss={closeSuggestionModal}
                    position={"center"}
                />
            )}


            <VerticalPageLayout className={`page-in-animation ${pageSwap && "page-out-animation"}`}>
                <HorizontalLayout style={{ width: "auto" }} className={"standard-padding"}>
                    <HeaderTitle title={"Rapporten"} />
                    <StandardButton className={"show-button"} size="medium" title={showMore ? "Toon minder" : "Toon meer"} onClick={() => setShowMore(!showMore)} />
                </HorizontalLayout>
                {allCourses.length > 0 && <SuggestedCourseGrid showMore={showMore}  selectedCourseIds={selectedCourseIds} selectCourse={handleCourseToggle} coursesToDisplay={displayedCourses} />}
                <Alert onClick={openSuggestionModal} className={"suggest-alert"} type="suggestion" buttonText={"Leer meer"} title={"Suggesties"} message={"Leer hoe je het maximale uit je e-learning kan halen met onze op maat gemaakte suggesties."} />
  
                        <VerticalLayout>
                            <ReportsOverview handleActiveGraph={handleActiveGraph} activeGraphId={activeGraphId} selectedCourses={selectedCourseIds}  graphDataset={graphDataset} courses={allCourses} setPeriod={setPeriod} period={period} keys={visibleKpiKeys} kpiContent={kpiContents} allReports={allReports} />
                        </VerticalLayout>
                        <VerticalLayout className="phone-raports">
                            <SuggestCourseTableComp margin={"0.8rem"} title={"Cursiststatistieken"} courses={userCourseStats} />
                        </VerticalLayout>
          
           
            </VerticalPageLayout>
        </>

    );
}
